"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultStatus = void 0;
var ResultStatus;
(function (ResultStatus) {
    ResultStatus[ResultStatus["New"] = 1] = "New";
    ResultStatus[ResultStatus["InReview"] = 2] = "InReview";
    ResultStatus[ResultStatus["Accepted"] = 4] = "Accepted";
    ResultStatus[ResultStatus["Invalid"] = 8] = "Invalid";
})(ResultStatus = exports.ResultStatus || (exports.ResultStatus = {}));
//# sourceMappingURL=ResultStatus.js.map